module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/roppoyaki-069130f1ad1d598348ae39903b660a18.jpg";